import { IsOptional } from 'class-validator';
import { Mapper } from '../../../common/ddd';
import { SelfChallengeTargetResultEntity } from '../../../core/domain/entities/challenge-target-result/self-challenge-target-result.entity';
import { IChallengeTargetResultEnum } from '../../../common/enum/challenge-target-result/challenge-target-result.enum';

export class SelfChallengeTargetResultPersistenceResponseDto {
  @IsOptional()
  [IChallengeTargetResultEnum.result]: string;
  @IsOptional()
  [IChallengeTargetResultEnum.localDate]: string;
}

export class SelfChallengeTargetResultMapper
  implements Omit<Mapper<SelfChallengeTargetResultEntity, any>, 'toResponse'>
{
  toDomain(
    record: SelfChallengeTargetResultPersistenceResponseDto
  ): SelfChallengeTargetResultEntity {
    return SelfChallengeTargetResultMapper.toDomain(record);
  }

  static toDomain(
    record: SelfChallengeTargetResultPersistenceResponseDto
  ): SelfChallengeTargetResultEntity {
    return SelfChallengeTargetResultEntity.create({
      result: Boolean(record[IChallengeTargetResultEnum.result]),
      localdate: new Date(record[IChallengeTargetResultEnum.localDate]),
    });
  }
}
